import { render, staticRenderFns } from "./vt-loading-button.vue?vue&type=template&id=155dc8cf&scoped=true&"
import script from "./vt-loading-button.ts?vue&type=script&lang=ts&"
export * from "./vt-loading-button.ts?vue&type=script&lang=ts&"
import style0 from "./vt-loading-button.scss?vue&type=style&index=0&id=155dc8cf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155dc8cf",
  null
  
)

export default component.exports